/* MARVI theme.js */
(function(){
  'use strict';

  // Header scroll
  var header = document.getElementById('SiteHeader');
  var annBar = document.querySelector('.ann-bar');
  window.addEventListener('scroll', function(){
    if(header){
      if(window.scrollY > 60){ header.classList.add('scrolled'); }
      else { header.classList.remove('scrolled'); }
    }
  }, {passive:true});

  // Mobile menu
  var btn = document.getElementById('MenuBtn');
  var nav = document.getElementById('MobileNav');
  if(btn && nav){
    btn.addEventListener('click', function(){
      var open = nav.classList.toggle('active');
      btn.classList.toggle('open', open);
    });
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        nav.classList.remove('active');
        btn.classList.remove('open');
      });
    });
  }

  // Count-up animation for impact numbers
  function countUp(el, target, duration){
    var start = 0;
    var startTime = null;
    var isDecimal = target % 1 !== 0;
    function step(timestamp){
      if(!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = start + (target - start) * ease;
      if(isDecimal){ el.textContent = '$' + current.toFixed(0); }
      else { el.textContent = Math.round(current).toLocaleString(); }
      if(progress < 1){ requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }

  function initCounters(){
    var counters = document.querySelectorAll('[data-count]');
    if(!counters.length) return;
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-count'));
          var prefix = el.getAttribute('data-prefix') || '';
          var suffix = el.getAttribute('data-suffix') || '';
          countUp(el, target, 2000);
          observer.unobserve(el);
        }
      });
    }, {threshold: 0.3});
    counters.forEach(function(c){ observer.observe(c); });
  }
  initCounters();

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var a = q.nextElementSibling;
      var open = q.classList.toggle('open');
      a.classList.toggle('open', open);
    });
  });

  // Product size selector
  document.querySelectorAll('.size-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var grid = btn.closest('.size-grid');
      grid.querySelectorAll('.size-btn').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Product thumb gallery
  document.querySelectorAll('.prod-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var wrap = thumb.closest('.prod-images');
      var main = wrap.querySelector('.prod-main-img img');
      var src = thumb.getAttribute('data-src');
      if(main && src){ main.src = src; }
      wrap.querySelectorAll('.prod-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Add to cart feedback
  document.querySelectorAll('.prod-add-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var orig = btn.textContent;
      btn.textContent = '✓ Added to cart';
      btn.style.background = '#2D6B82';
      setTimeout(function(){
        btn.textContent = orig;
        btn.style.background = '';
      }, 2500);
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });

})();
